import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import { IconButton, MenuItem, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import { JobsTab } from 'components/StudyDashboard/useStudyDashboardTabState';
import { stringify } from 'qs';
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { encodeQueryParams, JsonParam, StringParam } from 'use-query-params';
import { useCurrentLabId } from 'utils/useCurrentLab';

interface JobsControlProps {
  studyId: string;
  menuItem?: boolean;
}

const JobsControl: FunctionComponent<React.PropsWithChildren<JobsControlProps>> = ({ studyId, menuItem }) => {
  const navigate = useNavigate();
  const { labId } = useCurrentLabId();

  const navigateToJobs = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    const encodedQuery = encodeQueryParams(
      { filters: JsonParam, labId: StringParam, studyDashboardTab: StringParam },
      { filters: { studyId }, labId, studyDashboardTab: JobsTab }
    );

    navigate({
      pathname: `/procedures`,
      search: `?${stringify({ ...encodedQuery })}`,
    });
  };

  return menuItem ? (
    <MenuItem onClick={navigateToJobs}>
      <Box>
        <IconButton>
          <PendingActionsRoundedIcon />
        </IconButton>
      </Box>
      Jobs
    </MenuItem>
  ) : (
    <Tooltip title="Jobs" placement="top">
      <Box>
        <IconButton onClick={navigateToJobs}>
          <PendingActionsRoundedIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default JobsControl;
